import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { PregnancyDiagnosisParams, CoverageProcessParams } from 'src/domain/coverage-process'

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useCreateCouple() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['createCouple'],
    mutationFn: (params: { diagnosisData: PregnancyDiagnosisParams; coverageData: CoverageProcessParams }) =>
      pregnancyDiagnosisController.createCouple(farmId!, params.diagnosisData, params.coverageData),
    onError: () => {
      toast.error('Erro ao criar casal')
    }
  })
}
